import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { SET_CURVA_ABC_INIT } from '../actionTypes';
import {
  setCurvaAbcSuccess,
  errorCurvaMsg,
} from './actions';
import { atualizaCurvaAbc } from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';

// Atualizar Curva Abc -------------------------
const fetchAtualizaCurvaAbc = async (empId: string, payload: any) => {
  const { status, mensagem } = await atualizaCurvaAbc(empId, payload);
  if (status) {
    return { isUpdated: true, msg: mensagem };
  } else {
    return { isUpdated: false, msg: mensagem };
  }
};

function* parseAtualizarCurvaAbc({ payload }: { payload: any, type: any }) {
  const { empId, categorias, parametroD } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizaCurvaAbc,
      empId,
      {
        categorias,
        parametroD
      }
    );
    if (isUpdated) {
      yield put(setCurvaAbcSuccess({ msg }));
    } else {
      yield put(errorCurvaMsg({ msg }));
    }
  } catch (error: any) {
    yield put(errorCurvaMsg({ msg: error.mensagem }));
  }
}

export function* watchAtualizarCurvaAbc() {
  yield takeEvery(SET_CURVA_ABC_INIT, parseAtualizarCurvaAbc);
}

// WATCHS ------------------------------------------------
export default function* rootSaga() {
  yield all([fork(watchAtualizarCurvaAbc)]);
}
